import React from 'react';
import { useHistory } from 'react-router-dom';
import { generateAdminPath } from 'src/app/shared/utils/generateAdminPath';
import { AdminRoutePath } from 'src/app/routes/model';
import { useSupportDialogUnreadCount } from 'src/entities/supportDialog';
import { SidebarSectionWithoutItems } from '../../section';

export const MessagesSidebarSection: React.FC = () => {
  const unreadMessagesCount = useSupportDialogUnreadCount();
  const history = useHistory();
  const url = generateAdminPath(AdminRoutePath.Messages);

  return (
    <SidebarSectionWithoutItems
      badgeValue={unreadMessagesCount > 0 ? unreadMessagesCount : undefined}
      href={url}
      onClick={(e) => {
        e.preventDefault();
        history.push(url);
      }}
      title="Сообщения"
    />
  );
};
